import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

type Props = {
  design_type?: number;
};

export const Thumb = styled.div<Props>`
  position: relative;
  width: calc(100% + 10px);
  margin-left: -10px;
  margin-bottom: 10px;

  @media ${device.mobile} {
    padding-top: 76.4%;

    /* aspect-ratio: 310 / 230; */
    min-height: 230px;
    ${({ design_type }) => ((design_type ?? 0) > 2 ? "display: none;" : "")}
    ${({ design_type }) => {
      if (design_type === 2) {
        return `
        margin-left: 0;
        margin-right: -10px
    `;
      }
    }}
  }

  @media ${device.desktop} {
    visibility: ${({ design_type }) =>
      (design_type ?? 0) > 2 ? "hidden" : "inherit"};
    width: 57.5%;
    height: auto;
    margin-bottom: 0;

    ${({ design_type }) => {
      if (design_type === 1) {
        return `
        margin-left: -20px;
        margin-right: 30px;
    `;
      }
    }}
    ${({ design_type }) => {
      if (design_type === 2) {
        return `
        margin-left: 30px;
        margin-right: -20px;
    `;
      }
    }}
  }
`;

export const Image = styled.img<Props>`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;

  @media ${device.mobile} {
    position: absolute;
    top: 0;
  }

  ${({ design_type }) => {
    if (design_type === 1) {
      return `
            border-radius: 0px 10px 10px 0px;
    `;
    }
    if (design_type === 2) {
      return `
            border-radius: 10px 0px 0px 10px;
    `;
    }
  }}
`;

export const Wraper = styled.div<Props>`
  //position: relative;
  padding: 10px 10px 0;
  z-index: 10;


  @media ${device.mobile} {
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
    bottom: 5px;

    ${({ design_type }) => {
      if ((design_type ?? 0) === 2) {
        return `
        //height: calc(100% - 271px);
        }`;
      }
    }}

    ${({ design_type }) => {
      if ((design_type ?? 0) > 2) {
        return `
        min-height: calc(100vh - 28px);
        position: unset;
        }`;
      }
    }}
  }

  ${({ design_type }) => {
    if ((design_type ?? 0) > 2) {
      return `
        &::after {
                content: " ";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.25);
                backdrop-filter: blur(7.5px);
                z-index: -1;
                border-radius: 10px;
            }`;
    }
  }}

  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    width: 42.5%;

    ${({ design_type }) => {
      if (design_type === 1) {
        return `
        padding: 30px 10px 0 0;
    `;
      }
    }}
    ${({ design_type }) => {
      if (design_type === 2) {
        return `
        padding: 30px 0 0 10px;
    `;
      }
    }}
${({ design_type }) => {
      if (design_type === 3) {
        return `
        width: 46.2%;
        padding: 30px 30px 20px 10px;
        position: relative;
        &::after {
            left: -20px;
            width: calc(100% + 20px);
            border-radius: 0;
        }`;
      }
    }}
${({ design_type }) => {
      if (design_type === 4) {
        return `
        width: 46.2%;
        padding: 30px 10px 20px 30px;
        position: relative;

        &::after {
            right: -20px;
            width: calc(100% + 20px);
            border-radius: 0;
        }`;
      }
    }}
    ${({ design_type }) => {
      if (design_type === 5) {
        return `
        width: 100%;
        padding: 77px 130px 20px 130px;
        border-radius: 0px 10px 10px 0px;
        position: relative;

        &::after {
                width: calc(100% + 20px);
                border-radius: 0px 10px 10px 0px;
            }`;
      }
    }}
    ${({ design_type }) => {
      if (design_type === 6) {
        return `
        align-items: center;
        width: 100%;
        padding: 77px 130px 20px 130px;
        border-radius: 10px;

        &::after {
                width: 100%;
                border-radius: 10px;
            }`;
      }
    }}
  }
`;

export const BoxText = styled.div<Props>`
  margin-bottom: 20px;

  @media ${device.mobile} {
    ${({ design_type }) => {
      if ((design_type ?? 0) > 2) {
        return `
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-grow: 2;
    `;
      }
    }}
  }

  ${({ design_type }) => {
    if (design_type === 6) {
      return `
        align-items: center;
        text-align: center;
    `;
    }
  }}

  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 60px;
    flex-grow: 1;

    ${({ design_type }) => {
    if (design_type === 6) {
      return `
        align-items: center;
        text-align: center;
    `;
    }
  }}
  }
`;

export const Title = styled.h1`
  margin-bottom: 10px;
  text-align: inherit;
  font-weight: normal;
  font-size: 27px; //25
  line-height: 1.2;
  color: var(--title-text-color);
`;

export const Text = styled.p`
  margin-bottom: 20px;
  text-align: inherit;
  font-weight: 400;
  font-size: 13px; //12
  line-height: 1.33;
  color: var(--text-color);

  @media ${device.desktop} {
    margin-bottom: 10px;
    line-height: 1.5;
  }
`;

export const BoxContainer = styled.div<Props>`
  ${({ design_type }) => {
    if ((design_type ?? 0) > 2) {
      return `
        display: flex;
        flex-direction: column;
        `;
    }
  }}
  ${({ design_type }) => {
    if (design_type === 6) {
      return `
        align-items: center;
        text-align: center;
        `;
    }
  }}
`;

export const TextTitle = styled.p`
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: inherit;
  font-weight: 600;
  font-size: 8px;
  line-height: 2;
  text-transform: uppercase;
  color: var(--title-text-color);
`;

export const BoxBonuse = styled.div`
  display: grid;
  grid-template-columns: minmax(130px, 1fr) minmax(130px, 1fr);
  justify-content: center;
  grid-gap: 20px;
  width: 100%;
  max-width: 310px;
  height: 60px;
  margin-bottom: 10px;

  @media ${device.desktop} {
    grid-template-columns: minmax(140px, 1fr) minmax(140px, 1fr);
    grid-gap: 10px;
    margin-bottom: 0px;
  }
`;
